import { axios } from '@/utils/request'

// 作业人员列表，作业列表，获取当前登录人角色，获取单位
export function getList(params) {
  return axios(({
    url: '/jsonApi/get',
    method: 'post',
    data: params
  }))
}

// 新增作业，保存上传文件的数据，记录查看人
export function postAction(topic) {
  return axios({
    url: '/jsonApi/post',
    method: 'post',
    data: topic
  })
}

// 更新作业，发布作业
export function putAction(parameter) {
  return axios({
    url: '/jsonApi/put',
    method: 'put',
    data: parameter
  })
}

// 文件上传接口
// export function uploadAction(files) {
//   return axios({
//     url: '/sys/common/upload',
//     method: 'post',
//     data: files,
//     timeout: 3 * 1000
//   })
// }

// 删除上传文件，删除作业
export function deleteAction(parameter) {
  return axios({
    url: '/jsonApi/delete',
    method: 'delete',
    data: parameter
  })
}

// 浏览---------------
export function getTopic(params) {
  return axios({
    url: `/community/post`,
    method: 'get',
    params: params
  })
}

// 浏览
export function getQueryById(params) {
  return axios({
    url: `/community/post/queryById`,
    method: 'get',
    params: params
  })
}

// 获取详情页推荐
export function getRecommendTopics(id) {
  return axios({
    url: '/community/post/recommend',
    method: 'get',
    params: {
      topicId: id
    }
  })
}

export function update(topic) {
  return axios({
    url: '/community/post/update',
    method: 'post',
    data: topic
  })
}

export function deleteTopic(id) {
  return axios({
    url: `/community/post/delete/${id}`,
    method: 'delete'
  })
}

export function deleteComment(parameter) {
  return axios({
    url: `/community/comment/delete_comment`,
    method: 'delete',
    params: parameter
  })
}

export function thumbsUp(parameter) { // 评论点赞
  return axios({
    url: '/community/comment/thumbsUp',
    method: 'put',
    data: parameter
  })
}

export function postThumbsUp(parameter) { // 帖子点赞
  return axios({
    url: '/community/post/thumbsUp',
    method: 'put',
    data: parameter
  })
}



// 获取作业人员
export function getPersionWork(params) {
  return axios({
    url: '/sys/user/queryByOrgCode',
    method: 'get',
    params
  })
}